export function formatViews(count: number): string {
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)} 万`;
  }
  return `${count}`;
}

export function categoryBadgeClass(slug: string): string {
  switch (slug) {
    case 'political-correctness':
      return 'bg-secondary-100 text-secondary-800 border-secondary-200';
    case 'value-clash':
    case 'car-crash':
      return 'bg-accent-100 text-accent-800 border-accent-200';
    default:
      return 'bg-primary-100 text-primary-700 border-primary-200';
  }
}